export function exportMentorRatesAPI(authToken: string): Promise<Blob> {
    return fetch(process.env.REACT_APP_API_URL + '/mentors/export_rates', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/pdf',
            "Authorization": `Bearer ${authToken}`
        },
    }).then((response) => response.blob());
}